import React from "react";

const Popup = ({ handleClose, show, children }) => {
    const showHideClassName = show ? "modal d-block" : "modal d-none";

    return (
        <div className={showHideClassName} style={{ padding: '12%' }}>
            <div className="popup-box">
                <div className="box" style={{ maxWidth: '30%' }}>
                    <div className="modal-container">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;
